import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

const REGION_ID = "vs-qr-reader-region";

export function QrScanner({ onScan }) {
  const scannerRef = useRef(null);
  const handledRef = useRef(false);

  useEffect(() => {
    const q = new Html5Qrcode(REGION_ID);
    scannerRef.current = q;
    q.start(
      { facingMode: "environment" },
      { fps: 10, qrbox: { width: 240, height: 240 } },
      (decoded) => {
        if (handledRef.current) return;
        handledRef.current = true;
        q.stop().catch(() => {}).finally(() => onScan(decoded));
      },
      () => {}
    ).catch(() => {});

    return () => {
      try {
        if (q && q.isScanning) q.stop().catch(() => {});
        q.clear();
      } catch (_) { /* noop */ }
    };
  }, [onScan]);

  return <div id={REGION_ID} className="w-full overflow-hidden rounded-xl" data-testid="qr-scanner-region" />;
}
